// Author Lin
// Date 2021-12-06 16:22:01

class MintalMesInventoryInputOutput {
    constructor({
            id = null,
            materialId = '',
            materialName = '',
            warehouseId = '',
            warehouseName = '',
            orderCode = '',
            orderQuantity = '',
            grade = '',
            quantity = '',
            opertionTime = '',
            operationType = '',
            operator = '',
            operatorName = '',
            reviewer = '',
            reviewerName = '',
            weighSystemId = '',
            remark = ''}
    = {}) {
        this.id = id;
        this.materialId = materialId;
        this.materialName = materialName;
        this.warehouseId = warehouseId;
        this.warehouseName = warehouseName;
        this.orderCode = orderCode;
        this.orderQuantity = orderQuantity;
        this.grade = grade;
        this.quantity = quantity;
        this.opertionTime = opertionTime;
        this.operationType = operationType;
        this.operator = operator;
        this.operatorName = operatorName;
        this.reviewer = reviewer;
        this.reviewerName = reviewerName;
        this.weighSystemId = weighSystemId;
        this.remark = remark;
    }
    }
    
    function newEntity() {
    return new MintalMesInventoryInputOutput();
    }
    
        function gridFields() {
        return Object.freeze([
            {
            key: 'id',
            label: 'label.mintal.inventory.mintalMesInventoryInputOutput.grid.id',
            sortable: true,
                isDetail: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'materialId',
            label: 'label.mintal.inventory.mintalMesInventoryInputOutput.grid.materialId',
            sortable: true,
                isDetail: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'materialName',
            label: 'label.mintal.inventory.mintalMesInventoryInputOutput.grid.materialName',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'warehouseId',
            label: 'label.mintal.inventory.mintalMesInventoryInputOutput.grid.warehouseId',
            sortable: true,
                isDetail: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'warehouseName',
            label: 'label.mintal.inventory.mintalMesInventoryInputOutput.grid.warehouseName',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'orderCode',
            label: 'label.mintal.inventory.mintalMesInventoryInputOutput.grid.orderCode',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'orderQuantity',
            label: 'label.mintal.inventory.mintalMesInventoryInputOutput.grid.orderQuantity',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'grade',
            label: 'label.mintal.inventory.mintalMesInventoryInputOutput.grid.grade',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'quantity',
            label: 'label.mintal.inventory.mintalMesInventoryInputOutput.grid.quantity',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'opertionTime',
            label: 'label.mintal.inventory.mintalMesInventoryInputOutput.grid.opertionTime',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'operationType',
            label: 'label.mintal.inventory.mintalMesInventoryInputOutput.grid.operationType',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'operator',
            label: 'label.mintal.inventory.mintalMesInventoryInputOutput.grid.operator',
            sortable: true,
                isDetail: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'operatorName',
            label: 'label.mintal.inventory.mintalMesInventoryInputOutput.grid.operatorName',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'reviewer',
            label: 'label.mintal.inventory.mintalMesInventoryInputOutput.grid.reviewer',
            sortable: true,
                isDetail: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'reviewerName',
            label: 'label.mintal.inventory.mintalMesInventoryInputOutput.grid.reviewerName',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'weighSystemId',
            label: 'label.mintal.inventory.mintalMesInventoryInputOutput.grid.weighSystemId',
            sortable: true,
                isDetail: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'remark',
            label: 'label.mintal.inventory.mintalMesInventoryInputOutput.grid.remark',
            sortable: true,
                isDetail: true,
            form: {
            type: 'textarea'
            }
            }
        ])}
    
    const filter = {
        idFilter : '',
        idListFilter : [],
        materialIdFilter : '',
        materialNameFilter : '',
        warehouseIdFilter : '',
        warehouseNameFilter : '',
        orderCodeFilter : '',
        orderQuantityFilter : '',
        gradeFilter : '',
        quantityFilter : '',
        opertionTimeRteFilter : '',
        opertionTimeLteFilter : '',
        operationTypeFilter : '',
        operatorFilter : '',
        operatorNameFilter : '',
        reviewerFilter : '',
        reviewerNameFilter : '',
        weighSystemIdFilter : ''
    };
    
    const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));
    
    const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));
    
    const filterConfigs = [
            {
            key: 'materialNameFilter',
            label: 'label.mintal.inventory.mintalMesInventoryInputOutput.filter.materialName',
            disabled: false,
            form: {
            type: 'entityModalSelect'
                ,entity: 'mintalMesMstMaterial'
                ,correspondingField: 'name'
                ,fieldsBindingByEntityModalSelected: '{"materialId":"id"}'
                    }
            },
            {
            key: 'warehouseNameFilter',
            label: 'label.mintal.inventory.mintalMesInventoryInputOutput.filter.warehouseName',
            disabled: false,
            form: {
            type: 'entityModalSelect'
                ,entity: 'mintalMesMstWarehouse'
                ,correspondingField: 'warehouseName'
                ,fieldsBindingByEntityModalSelected: '{"warehouseId":"id"}'
                    }
            },
            {
            key: 'orderCodeFilter',
            label: 'label.mintal.inventory.mintalMesInventoryInputOutput.filter.orderCode',
            disabled: false,
            form: {
            type: 'input'
                    }
            },
            {
            key: 'gradeFilter',
            label: 'label.mintal.inventory.mintalMesInventoryInputOutput.filter.grade',
            disabled: false,
            form: {
            type: 'input'
                    }
            },
            {
            key: 'opertionTimeRteFilter',
            label: 'label.mintal.inventory.mintalMesInventoryInputOutput.filter.opertionTimeRte',
            disabled: false,
            form: {
            type: 'datetimepicker'
                    }
            },
            {
            key: 'opertionTimeLteFilter',
            label: 'label.mintal.inventory.mintalMesInventoryInputOutput.filter.opertionTimeLte',
            disabled: false,
            form: {
            type: 'datetimepicker'
                    }
            },
            {
            key: 'operationTypeFilter',
            label: 'label.mintal.inventory.mintalMesInventoryInputOutput.filter.operationType',
            disabled: false,
            form: {
            type: 'select'
                ,showLabelSelectOne: true
             ,options: [
                    { value: '1', text: '入库' },
                    { value: '2', text: '出库' }
                ]
            }
            },
            {
            key: 'operatorNameFilter',
            label: 'label.mintal.inventory.mintalMesInventoryInputOutput.filter.operatorName',
            disabled: false,
            form: {
            type: 'entityModalSelect'
                ,entity: 'emAclUser'
                ,correspondingField: 'name'
                ,fieldsBindingByEntityModalSelected: '{"operator":"id"}'
                    }
            },
            {
            key: 'reviewerNameFilter',
            label: 'label.mintal.inventory.mintalMesInventoryInputOutput.filter.reviewerName',
            disabled: false,
            form: {
            type: 'entityModalSelect'
                ,entity: 'emAclUser'
                ,correspondingField: 'name'
                ,fieldsBindingByEntityModalSelected: '{"reviewer":"id"}'
                    }
            },
    ];
    
    
        const entityFormConfigs = [
            {
            key: 'materialName',
            label: 'label.mintal.inventory.mintalMesInventoryInputOutput.entity.materialName',
            sortable: true,
            disabled: false,
            form: {
            type: 'entityModalSelect'
                ,entity: 'mintalMesMstMaterial'
                ,correspondingField: 'name'
                ,fieldsBindingByEntityModalSelected: '{"materialId":"id"}'
                    }
            },
            {
            key: 'warehouseName',
            label: 'label.mintal.inventory.mintalMesInventoryInputOutput.entity.warehouseName',
            sortable: true,
            disabled: false,
            form: {
            type: 'entityModalSelect'
                ,entity: 'mintalMesMstWarehouse'
                ,correspondingField: 'warehouseName'
                ,fieldsBindingByEntityModalSelected: '{"warehouseId":"id"}'
                    }
            },
            {
            key: 'orderCode',
            label: 'label.mintal.inventory.mintalMesInventoryInputOutput.entity.orderCode',
            sortable: true,
            disabled: false,
            form: {
            type: 'input'
                ,required: true
                    }
            },
            {
            key: 'orderQuantity',
            label: 'label.mintal.inventory.mintalMesInventoryInputOutput.entity.orderQuantity',
            sortable: true,
            disabled: false,
            form: {
            type: 'input'
                    }
            },
            {
            key: 'grade',
            label: 'label.mintal.inventory.mintalMesInventoryInputOutput.entity.grade',
            sortable: true,
            disabled: false,
            form: {
            type: 'input'
                ,required: true
                    }
            },
            {
            key: 'quantity',
            label: 'label.mintal.inventory.mintalMesInventoryInputOutput.entity.quantity',
            sortable: true,
            disabled: false,
            form: {
            type: 'inputNumber'
                ,required: true
                    }
            },
            {
            key: 'opertionTime',
            label: 'label.mintal.inventory.mintalMesInventoryInputOutput.entity.opertionTime',
            sortable: true,
            disabled: false,
            form: {
            type: 'datetimepicker',
            required: true
                    }
            },
            {
            key: 'operationType',
            label: 'label.mintal.inventory.mintalMesInventoryInputOutput.entity.operationType',
            sortable: true,
            disabled: false,
            form: {
            type: 'select'
                ,required: true
                ,showLabelSelectOne: true
            ,options: [
                    { value: '1', text: '入库' },
                    { value: '2', text: '出库' }
                ]
            }
            },
            {
            key: 'operatorName',
            label: 'label.mintal.inventory.mintalMesInventoryInputOutput.entity.operatorName',
            sortable: true,
            disabled: false,
            form: {
            type: 'entityModalSelect'
                ,entity: 'emAclUser'
                ,correspondingField: 'name'
                ,fieldsBindingByEntityModalSelected: '{"operator":"id"}'
                    }
            },
            {
            key: 'reviewerName',
            label: 'label.mintal.inventory.mintalMesInventoryInputOutput.entity.reviewerName',
            sortable: true,
            disabled: false,
            form: {
            type: 'entityModalSelect'
                ,entity: 'emAclUser'
                ,correspondingField: 'name'
                ,fieldsBindingByEntityModalSelected: '{"reviewer":"id"}'
                    }
            },
            {
            key: 'remark',
            label: 'label.mintal.inventory.mintalMesInventoryInputOutput.entity.remark',
            sortable: true,
            disabled: false,
            form: {
            type: 'textarea'
                    }
            }
    ]
    
    export {MintalMesInventoryInputOutput, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs
    
    
    }
    